import split from '@os/split-point';

function load() {
	return import( /* webpackChunkName: "dynamic-stock-chart" */ './full-dynamic-stock-chart');
}

export default split(load);
